import { useStore } from '../../store/hooks'
import ProductAvailabilityStore from '../ProductAvailabilityStore'
import { Box, Text } from '@thirstycamel/ui'
import CoreProductEntity from '@ts/core/src/modules/coreproduct/coreproduct.entity'
import { ProductSourceOptions } from '../ProductSource'

export interface ProductAvailabilityProps {
  product: CoreProductEntity
  productSource?: ProductSourceOptions
}

export const ProductAvailability = ({ product, productSource }: ProductAvailabilityProps) => {
  const selectedStore = useStore(s => s.store.selectedStore)

  if (!product?.id) {
    return null
  }

  if (!selectedStore) {
    return null
  }

  return <ProductAvailabilityStore product={product} productSource={productSource} />
}

export default ProductAvailability
